module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2b"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('strong', [_c('em', [_vm._v("Three Cheers from the Baltimoreans")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OON AFTER THE START OF THE WAR, NEWLY ORGANIZED")]), _vm._v(" volunteers converged on Camp Lee, near Richmond, Virginia, to muster into the army as the Twenty-first Virginia Infantry. On June 21, 1861, the two companies that would form the heart and soul of the regiment met for the first time: Company B, a select group of Baltimore’s cultural and financial elite, welcomed Company F, an old militia organization composed of the crème de la crème of Richmond society. The Baltimoreans gave the Richmonders three hearty cheers."), _c('a', {
    attrs: {
      "id": "ren6"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#en6",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Company B’s officer corps included 1st Lt. Richard Hoffman, the son of a prosperous merchant of German ancestry. His mother gave birth to him in the family’s Baltimore mansion, and he attended private schools in the city and became a successful stockbroker."), _c('a', {
    attrs: {
      "id": "ren7"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#en7",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("7")])]), _vm._v(" He joined a company in the Maryland Guard Battalion, a militia unit formed in Baltimore in 1859. In the wake of the bombardment of Fort Sumter, fifty-six of the sixty-eight members resigned and left for Virginia with Hoffman in command, and Company B was dissolved. The men took part of the company name with them, re-forming as the Maryland Guard Company in May 1861. They became the only Maryland-based company in the otherwise all-Virginia Twenty-first Infantry. Their unique uniforms, influenced by the fancy Zouave style, reinforced their out-of-state distinction."), _c('a', {
    attrs: {
      "id": "ren8"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#en8",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Marylanders signed up for a one-year enlistment in the Twenty-first. They spent most of their time in the Shenandoah Valley, where they saw little action, and left the regiment after their term expired. Many of the men were recruited for an all-sharpshooters unit; Hoffman signed on as captain and head of Company E of the Thirtieth Battalion Virginia Sharpshooters.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("Capt. Hoffman spent significant amounts of time away from his new command. Military authorities detached him for a variety of duties, including recruiting, hunting for deserters, and serving on a board of courts martial. He tendered his resignation in February 1865. Gen. Robert E. Lee refused to accept it, and he remained in the army for two more months."), _c('a', {
    attrs: {
      "id": "ren9"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#en9",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After the war, Hoffman returned to Baltimore and entered the coal business, opening his own firm in 1875. Among his other business interests was the Seaboard Air Line Railroad, and in 1877, a stop along a new rail line in Western Maryland was named for him. It attracted a small population, and the following year the fledgling community established a post office. Hoffman, Maryland, later became an incorporated town. In 1893, he assumed the presidency of the railroad company. During his two-year tenure in that post, he successfully fought a hostile takeover attempted by J. P. Morgan and a group of New York businessmen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 1880, at age forty-one, Hoffman married and started a family that grew to include six children. He belonged to several social clubs and Confederate veterans’ groups. He lived until the age of eighty-six, dying in 1926."), _c('a', {
    attrs: {
      "id": "ren10"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#en10",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("10")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5739cb62","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter1.vue
// module id = 87
// module chunks = 0